import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PermissionLoaderService } from 'src/app/services/permission-loader.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api/messageservice';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnDestroy {

  licenseOus: any;
  staticURL = GlobalConstants.staticFilesURL;
  loading: boolean = false;
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  showAnnouncement = false;
  announcements: any;
  assessment: any;
  closable = true;

  //Popup messages
  messages: any[] = [];
  ignoreCount: number = 0;
  startQuiz = false;

  constructor(
    public permissionService: PermissionHandlerService,
    private permissionLoader: PermissionLoaderService,
    private dataService: DataService,
    private router: Router,
  ) { }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasContentDefaultPermisssion() {
    console.log(this.permissionService.payload.content.allow)
    return this.permissionService.payload.content.allow
  }

  reloadPage() {
    window.location.href = '/home';
  }

  private permissionLoaderSub?: Subscription;
  // If the role never arrives, stop showing placeholders rather than hang.
  private loadGaveUp = false;
  private loadGiveUpTimer: any;

  // One skeleton for the whole page until the loader is idle and, for a
  // guest, the default role is in. A guest goes through two loads (empty,
  // then the default role), so "done" alone is not enough.
  get pageLoading(): boolean {
    if (this.loadGaveUp) return false;
    if (this.loading || !this.permissionLoader.isLoaded) return true;
    // Signed-in roles can legitimately have no permissions; only a guest
    // needs to wait for the default role to arrive.
    return !this.isLoggedIn && !this.permissionService.hasLoadedRole;
  }

  ngOnDestroy(): void {
    this.permissionLoaderSub?.unsubscribe();
    clearTimeout(this.loadGiveUpTimer);
  }

  ngOnInit() {
    let JustLoggedIn = localStorage.getItem('JustLoggedIn');

    if (JustLoggedIn == 'Yes') {
      localStorage.setItem('JustLoggedIn', 'No');

      this.reloadPage();
    }

    if(this.isLoggedIn) {
    this.getAllActive();
    }
    // let isTrainingVisible = this.isTrainingVisible();
    // 
    // if(this.isTrainingVisible()) {
    //   this.products.push()
    // }

    this.products

    console.log("IS LOGGGED IN!!!", this.isLoggedIn);
    console.log("HAS PERMISSION", (!this.isLoggedIn && this.hasContentDefaultPermisssion()))
    this.permissionLoaderSub = this.permissionLoader.getState().subscribe(e => {
      this.loading = e;
    })
    this.loadGiveUpTimer = setTimeout(() => this.loadGaveUp = true, 15000);

  }

  // Background animation properties
  products = [
    {
      name: 'التدريب',
      description: 'طوّر مهاراتك واطّلع على البرامج التدريبية',
      image: '../../../assets/icones-2025/caro-6.jpeg',
      // Was '/training/user-trainings', whose route is commented out with the
      // rest of the old training URLs. Straight to the Tayseer portal's course
      // catalog — see `navigateToRoute` for why this one cannot go through the
      // router.
      route: '/training/continuous?view=available'
    },

    {
      name: 'دليل الخدمات الحكومية',
      description: 'تعرّف على الخدمات ومتطلباتها',
      image: '../../../assets/icones-2025/caro-1.jpeg',
      route: '/all-data-view'
    },
    {
      name: 'مكتبة المعرفة',
      description: 'تصفّح الأدلة والمراجع المعرفية',
      image: '../../../assets/icones-2025/caro-4.jpeg',
      route: '/knowledge-library'
    },
    // {
    //   name: 'المفضلة ',
    //   image: '../../../assets/icones-2025/caro-3.jpeg',
    //   route: '/search-view'
    // },

    // {
    //   name: 'سأعرض مثال',
    //   image: '../../../assets/icones-2025/caro-5.jpeg',
    //   route: '/notification'
    // }
  ];
  currentBackgroundIndex = 0;
  private backgroundTimer: any;

  getAllActive = async () => {
    try {
      const res = await this.dataService.getData('announcement/allActive');
      console.log("annoucement ran")
      if (res.error) {
        return;
      }
      console.log("res", res);
      if (res.data.length > 0) {
        this.announcements = res.data[0];
        this.showAnnouncement = true;
        if (this.announcements.assessmentId) {
          let assessmentRes = await this.dataService.getData(
            `assessment/id/${this.announcements.assessmentId}`
          );

          if (!assessmentRes.error) {
            this.populateAssessment(assessmentRes.data);
          }
        }
      }
      console.log("this.announcements", this.announcements);
    } catch (error) {
    }
  };


  populateAssessment(data: any) {
    console.log("assessment adata", data)
    this.announcements.image = data.headerImage;
    // this.announcements.description = data.comments;
    this.ignoreCount = 0;

    this.announcements.ignoredBy.forEach((id: string) => {
      if (id == localStorage.getItem('uid')) {
        this.ignoreCount++;
      }
    });

    if (this.announcements?.ignoreLimit && this.ignoreCount > this.announcements?.ignoreLimit) {
      this.closable = false;
    }

    this.assessment = data;
  }

  async assessmentSubmit() {
    let email = localStorage.getItem('email');
    if (email) {
      this.assessment.email = email;
    }

    // Check if any question has an empty meta.value
    let unanswered = this.assessment.questions.some((q: any) => q.meta?.value === "");

    if (unanswered) {
      this.messages = [
        {
          severity: 'error',
          summary: this.translate('All questions not answered'),
          detail: this.translate("Please answer all questions")
        }
      ];
      return; // Stop further execution
    }




    let res = await this.dataService.postData(
      `assessment/submit`,
      this.assessment
    );

    if (res.error) {
      return;
    } else {
      this.generateAssessmentResults();
      this.showAnnouncement = false;

    }
  }

  navigateToRoute(route: string) {
    if (route && route !== '/example') {
      // The Tayseer portal is a separate app served same-origin under
      // /training, so the router cannot reach it — it would resolve the path
      // against this app's own routes and land on home instead.
      if (route.startsWith('/training/')) {
        window.location.href = route;
        return;
      }
      if (route === '/search-view') {
        // For favorites, navigate with query parameters like the navbar
        let queryParams = { searchTerm: 'fav' };
        this.router.navigate([route], { queryParams });
      } else {
        this.router.navigate([route]);
      }
    }
  }

  async generateAssessmentResults() {
    try {
      let res = await this.dataService.postData(
        `assessment-result/generate`,
        ''
      );
      let res2 = await this.dataService.postData('announcement/UpdateSeenBy/' + this.announcements._id, null, 'POST', false);
    } catch (e) { }
  }

  setAnnouncementSeenBy = async (id: string) => {
    try {
      if (!this.announcements.assessmentId) {
        let res = await this.dataService.postData('announcement/UpdateSeenBy/' + id, null, 'POST', false);
      } else {
        let res = await this.dataService.postData('announcement/UpdateIgnoredBy/' + id, null, 'POST', false);
      }
    } catch (error) {
      console.log(error);
    }
  };
}
